// extracted by mini-css-extract-plugin
export default {"priorityLowIcon":"styles__priorityLowIcon__a52374f9c9fc676ad221"};